import React from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import StarBG from "./rsc/Stars.jpg";
import Logo from "./rsc/Logo.png";
import Screenshot1 from "./rsc/Screenshot1.png";
import Screenshot2 from "./rsc/Screenshot2.png";
import "./Home.css";
import { HashLink as Link } from 'react-router-hash-link';
import { Helmet } from "react-helmet";

import {Icon, Segment, Header, Divider} from "semantic-ui-react";

import Interstitial from "./Interstitial";
import Contest from "./Contest";
import DownloadLinks from "./DownloadLinks";

const MOBILE_WIDTH = 700;

export default class Home extends React.Component {
    constructor(props){
        super(props);
        this.state = {contest: null};
        this.db = firebase.firestore();
        this.fetchContest();
    }

    fetchContest = () => {
        this.db.collection("contests").orderBy("start", "desc").limit(1).get().then((snap) => {
            if(snap.size == 0) return;
            snap.forEach((doc) => {
                let data = doc.data();
                data.__id = doc.id;
                this.setState({contest: data});
            });
        }, (e) => {
            console.error(e);
        });
    }

    render(){
        const seoStructuredData = (
            <script type="application/ld+json">
                {
                    `
                        {
                            "@context": "https://schema.org",
                            "@type": "SoftwareApplication",
                            "name": "Kartfinity",
                            "operatingSystem": ["OSX", "Windows"],
                            "applicationCategory": "GameApplication",
                            "installUrl": ["https://apps.apple.com/us/app/kartfinity/id1479337138", "https://www.microsoft.com/en-us/p/kartfinity/9nx4z7mjrkj1"],
                            "offers": {
                                "@type": "Offer",
                                "price": "0"
                            }
                        }
                    `
                }
            </script>
        );
        const starStyle = {
            backgroundImage: "url(" + StarBG + ")",
            color: "#FFFFFF",
            position: "relative",
            textAlign: "center",
            paddingTop: "2vh",
            backgroundSize: "cover",
            backgroundAttachment: "fixed"
        };
        const halfNhalf = {display: "inline-block", position: "relative", width: "50%", padding: "0 40px", verticalAlign: "top"};
        const screenshot = {maxWidth: "90%", borderRadius: "10px"};
        let timeUntilStart = this.state.contest == null ? 0 : (this.state.contest.start.toDate() - (new Date()));
        let timeUntilEnd = this.state.contest == null ? 0 : (this.state.contest.end.toDate() - (new Date()));
        return (
            <div id="home_page" style={{...starStyle}}>
                <Helmet>
                    <title>Kartfinity</title>
                    {seoStructuredData}
                </Helmet>
                <div className="pageSection" id="video">
                    {
                        (this.state.contest == null || timeUntilStart > 604800000 || timeUntilEnd < 0) ? null : ( //604800000: a week in millis.
                            <Link to="#contest" style={{color: "#FFFFFF"}}><p style={{fontSize: "3vh", textShadow: "0 0 15px #FEC400DD"}}><Icon name="rocket" />A <strong>building contest</strong> {timeUntilStart < 0 ? (timeUntilEnd < 604800000 ? "is ending soon" : "has started") : "is starting soon"}!</p></Link>
                        )
                    }
                    <img src={Logo} alt="Kartfinity Logo" style={{maxHeight: "30vh", marginTop: "8vh", marginBottom: "8vh"}} />
                    <DownloadLinks />
                    <iframe
                        title="Kartfinity Trailer"
                        style={{border: "none", borderRadius: "30px", boxShadow: "0 0 30px #00000088" }}
                        width="933"
                        height="525"
                        src="https://www.youtube.com/embed/-r5WKUODFoc"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
                <Interstitial />
                <div className="pageSection" id="features">
                    <div style={{...halfNhalf}}>
                        <Header inverted style={{fontSize: "5vh"}}>Infinite Driving</Header>
                        <p style={{fontSize: "3vh"}}>Drive around a never-ending racetrack with Infinite Mode, featuring tons of unique community-created levels.</p>
                        <img src={Screenshot1} alt="Screenshot of driving mode" style={screenshot} />
                    </div>
                    <div style={{...halfNhalf}}>
                        <Header inverted style={{fontSize: "5vh"}}>Level Creator</Header>
                        <p style={{fontSize: "3vh"}}>Create your own levels to be featured in Infinite Mode! There are no limits except your imagination.</p>
                        <img src={Screenshot2} alt="Screenshot of builder mode" style={screenshot} />
                    </div>
                </div>
                <Interstitial />
                <div className="pageSection">
                    <div>
                        <Header inverted style={{fontSize: "5vh"}}>Ready to Play?</Header>
                    </div>
                    <div style={{paddingTop: "5vh"}} /> 
                    
                    <DownloadLinks />
                        App Store is a service mark of Apple Inc.
                </div>
                <Interstitial />
                {
                    (this.state.contest == null || timeUntilEnd < 0) ? null :
                    (
                        <div>
                            <div className="pageSection">
                                <Contest titleText={timeUntilEnd < 0 ? "Previous Contest" : "Featured Contest"} data={this.state.contest} anchor />
                            </div>
                            <Interstitial />
                        </div>
                    )
                }
                <div style={{width: "100%", padding: "20px", color: "#FFFFFF", backgroundColor: "#000000", textAlign: "center"}}>
                    <p>Thanks for playing! <Icon name="heart" /> View our <Link to="/privacypolicy">privacy policy</Link> <Icon name="heart" /> Made by <a href="http://yoonicode.com">Yoonicode</a></p>
                </div>
            </div>
        );
    }
}